<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-2.5,802.5l-7-7v-1l1.79-1.79l-1.5-1.5l1.41-1.42l1.5,1.5l2.09-2.09l-1.5-1.5l1.41-1.41l1.5,1.5l2.09-2.09l-1.5-1.5
	l1.42-1.41l1.5,1.5l1.79-1.79h1l7,7v1l-1.79,1.79l1.5,1.5l-1.42,1.41l-1.5-1.5l-2.09,2.09l1.5,1.5l-1.42,1.42l-1.5-1.5l-2.08,2.09
	l1.5,1.5l-1.41,1.41l-1.5-1.5l-1.79,1.79H-2.5z M5.5,790.5l-3-3l-7,7l3,3L5.5,790.5z"/>
</svg>

</template>